/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckConnectivityEndpointResponse
 */
export interface CheckConnectivityEndpointResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckConnectivityEndpointResponse
     */
    success: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckConnectivityEndpointResponse
     */
    errors: Array<string>;
}

export function CheckConnectivityEndpointResponseFromJSON(json: any): CheckConnectivityEndpointResponse {
    return CheckConnectivityEndpointResponseFromJSONTyped(json, false);
}

export function CheckConnectivityEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckConnectivityEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errors': json['errors'],
    };
}

export function CheckConnectivityEndpointResponseToJSON(value?: CheckConnectivityEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'errors': value.errors,
    };
}


